/**
 * Cuadricula de Facturacion Global (CRM-3108).
 *
 * Se trabaja sobre 24 columnas en vez de las 12 por defecto: con 12 la
 * etiqueta solo podia valer 2 (16.7%) y "Facturacion No GN4" mas su casilla
 * Manual no cabian en un renglon. Con 24 la etiqueta vale 6 (25%) y los dos
 * importes siguen midiendo exactamente lo mismo.
 *
 * Las comparten TODAS las filas principales -- totales fijos y permisos
 * desplegables -- para que Total $ y Total Lt formen dos lineas verticales
 * continuas de arriba a abajo de la pantalla.
 */
export const ROW_GRID_COLUMNS = 24;

export const ROW_COLUMNS = {
  label: 6,
  totalAmount: 9,
  totalQuantity: 9,
};

/**
 * La primera columna es la unica que admite controles auxiliares (la casilla
 * Manual, el boton de desplegar): van pegados a la derecha dentro de ella,
 * sin empujar el inicio de la siguiente columna.
 */
export const labelCellStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 1,
  width: "100%",
  minWidth: 0,
};

export const labelTextStyle = {
  minWidth: 0,
  overflowWrap: "anywhere",
};

export const auxControlStyle = {
  flexShrink: 0,
  marginRight: 0,
  whiteSpace: "nowrap",
};

/**
 * Azul institucional: el mismo de los botones Buscar y Timbrar de la vista.
 * Se resalta con este color la etiqueta de cada permiso y los tres renglones
 * de facturacion (GN4, No GN4, Pendiente) en el pie.
 */
export const CORPORATE_BLUE = "#0d47a1";

export const accentLabelStyle = {
  color: CORPORATE_BLUE,
  fontWeight: 500,
};
